"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Database = void 0;
const dexie_1 = __importDefault(require("dexie"));
class Database extends dexie_1.default {
    constructor() {
        super('bf_sdk');
        this.version(1).stores({
            devicekeys: '++id, sessionUUID',
            issues: '++id, sessionUUID',
            logs: '++id, sessionUUID',
            sessions: 'uuid',
        });
        this.version(2).upgrade((tx) => {
            return tx.table('issues').toCollection().modify((issue) => {
                issue.data.text = issue.data.markdown;
                delete issue.data.markdown;
            });
        });
        this.devicekeys = this.table('devicekeys');
        this.issues = this.table('issues');
        this.logs = this.table('logs');
        this.sessions = this.table('sessions');
    }
}
exports.Database = Database;
